import React from "react";
import { Box, Image, Paper, Stack, Text, Title } from "@mantine/core";
import LoginBuildChip from "./Footer/LoginBuildChip";
import classes from "./PublicAuthShell.module.css";
export const DEFAULT_LOGO = "https://dlil96nns7nd5.cloudfront.net/images/isn-side-tm.png";
/**
 * Structural chrome only — the tinted shell, the centered 420px column, the
 * branding block and the build chip.
 *
 * Deliberately knows nothing about renderWebView beyond whether to draw a
 * footer: the pages differ in what webview mode means. Login hides its entire
 * form; the password screens keep their form and hide only the back link. That
 * decision stays with each page.
 */
export default function PublicAuthShell({ logoUrl, title, subtitle, showFooter = true, children, }) {
    return (React.createElement(Box, { mih: "100vh", bg: "gray.0", display: "flex", style: { flexDirection: "column" } },
        React.createElement("div", { className: classes.shell },
            React.createElement(Stack, { w: "100%", maw: 420, gap: 28 },
                React.createElement(Stack, { align: "center", gap: 14 },
                    React.createElement(Image, { src: logoUrl || DEFAULT_LOGO, alt: "Inspection Support Network", h: 44, w: "auto", fit: "contain" }),
                    React.createElement(Stack, { align: "center", gap: 4 },
                        React.createElement(Title, { order: 1, className: classes.title }, title),
                        subtitle && React.createElement(Text, { size: "sm", c: "dimmed" }, subtitle))),
                children)),
        showFooter && React.createElement(LoginBuildChip, null)));
}
/** The white card these screens put their form in. Separate from the shell so a
 *  page can omit it — login renders no card at all in webview mode. */
export function AuthCard({ children, flush = false }) {
    return (React.createElement(Paper, { radius: "md", shadow: "md", className: flush ? `${classes.card} ${classes.flush}` : classes.card }, children));
}
